module.exports = __webpack_public_path__ + "assets/media/phone.5df50358.mp3";